// extracted by mini-css-extract-plugin
export default {"wrapper":"error_wrapper__zPyaa","opacity-transition":"error_opacity-transition__Wq6cM"};